export const MONAMODI_AMENDMENT_OPTIONS = [
  {
    id: 'manage-members',
    title: 'Manage Members',
    description: 'Add or remove family members from the policy',
    icon: '👥'
  },
  {
    id: 'modify-member',
    title: 'Modify Member Details',
    description: 'Update member information (names, ID, phone, address)',
    icon: '✏️'
  },
  {
    id: 'manage-benefits',
    title: 'Manage Benefits',
    description: 'Add or remove optional benefits. Premiums update in real-time.',
    icon: '💎'
  },
  {
    id: 'change-plan',
    title: 'Change Plan',
    description: 'Switch to a different Monamodi plan',
    icon: '📋'
  },
  {
    id: 'change-coverage',
    title: 'Change Coverage Type',
    description: 'Switch between Member Only and Member & Family',
    icon: '🔄'
  }
];
